import { TICKS_PER_BEAT } from '../../shared/tempo';
import type { EnemyDefinition } from '../types';

export interface PuddleEffect {
  readonly kind: 'puddle';
  readonly radius: number;
  readonly driesBars: number;
}

export const ORAGE: EnemyDefinition = {
  id: 'orage',
  name: "L'Orage",
  description: 'Il noie les pièges sous ses flaques.',
  behaviour: 'boss',
  maxHp: 2000,
  speed: 0.8,
  radius: 46,
  damage: 30,
  attackCooldownTicks: 2 * TICKS_PER_BEAT,
  aggroRadius: 340,
  vibesDrop: 50,
  scalingPerPhrase: { hp: 1, speed: 1 },
  special: { kind: 'puddle', radius: 44, driesBars: 8 },
};
